import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { Authorized, LoginAuthorized } from './core/services';
import { UnauthorizedComponent } from './core/unauthorized.component';
import { LoginComponent, DashboardAdminComponent, NotFoundComponent, UsersComponent, ForgotPasswordComponent, ResetPassWordComponent } from './';
import { CampaignsComponent } from "./campaigns/campaigns.component";
import { CampaignDetailsComponent } from './campaigns/campaign-details.component';
import { BrandLogosComponent } from "./brand-logos/brand-logos.component";
import { BrandPreidComponent } from "./brand-preid/brand-preid.component";
import { MediationComponent } from './mediation';
import { PaymentComponent } from "./payment/payment.component";
import { AutoLoginComponent } from './core/auto-login.component';
import { ProvidersComponent } from "./providers/providers.component";
import { PublishersComponent } from "./publishers/publishers.component";
import { PublisherDashboardComponent } from "./dashboard/publisher-dashboard/publisher-dashboard.component";
import { ReportsComponent } from "./reports/reports.component";
import { CreativeComponent } from './creatives/creative.component';
import { AssetComponent } from './assets/asset.component';

export const routes: Routes = [
    {
        path: '',
        redirectTo: 'login',
        pathMatch: 'full'
    },
    {
        path: 'login',
        component: LoginComponent,
        canActivate: [LoginAuthorized]
    },
    {
        path: 'unauthorized',
        component: UnauthorizedComponent
    },
    {
        path: 'dashboard-admin',
        component: DashboardAdminComponent,
        canActivate: [Authorized]
    },
    {
        path: 'dashboard',
        component: PublisherDashboardComponent,
        canActivate: [Authorized]
    },
    {
        path: 'users',
        component: UsersComponent,
        canActivate: [Authorized]
    },
    {
        path: 'campaigns',
        component: CampaignsComponent,
        canActivate: [Authorized]
    },
    {
        path: 'campaigns/:from',
        component: CampaignsComponent,
        canActivate: [Authorized]
    },
    {
        path: 'campaign-details/:id',
        component: CampaignDetailsComponent,
        canActivate: [Authorized]
    },
    {
        path: 'campaign-details',
        component: CampaignDetailsComponent,
        canActivate: [Authorized]
    },
    {
        path: 'brand-logos',
        component: BrandLogosComponent,
        canActivate: [Authorized]
    },
    {
        path: 'brand-preid',
        component: BrandPreidComponent,
        canActivate: [Authorized]
    },
    {
        path: 'mediation',
        component: MediationComponent,
        canActivate: [Authorized]
    },
    {
        path: 'payment',
        component: PaymentComponent,
        canActivate: [Authorized]
    },
    {
        path: 'providers',
        component: ProvidersComponent,
        canActivate: [Authorized]
    },
    {
        path: 'publishers',
        component: PublishersComponent,
        canActivate: [Authorized]
    },
    {
        path: 'auto-login/:returnUrl',
        component: AutoLoginComponent
    },
    {
        path: 'reset-password',
        component: ForgotPasswordComponent,
        canActivate: [LoginAuthorized]
    },
    {
        path: 'reset-password/:token',
        component: ResetPassWordComponent,
        canActivate: [LoginAuthorized]
    },
    {
        path: 'reports',
        component: ReportsComponent,
        canActivate: [Authorized]
    },
    {
        path: 'creatives',
        component: CreativeComponent,
        canActivate: [Authorized]
    },
    {
        path: 'assets',
        component: AssetComponent,
        canActivate: [Authorized]
    },
    {
        path: '**',
        component: NotFoundComponent
    }
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
})
export class AppRoutingModule { }


// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts